import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill="currentcolor" d="M8.667 2v5.333H14v1.334H8.667V14H7.333V8.667H2V7.333h5.333V2z" fill-rule="evenodd"/></svg>`;

export { symbol as default };
